import { defineComponent, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import { TransactTypes } from '@/types/transact';
import { numberFormat } from '@/utils/helpers';
import useTransactionsStore from '../../store/modules/transactions';
import RateTimer from '../general/RateTimer.vue';
import RateRefreshedAlert from '../general/RateRefreshedAlert.vue';
export default defineComponent({
    name: 'BuyOrderSummaryComponent',
    components: {
        RateTimer,
        RateRefreshedAlert,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { selectedCurrency, selectedCrypto, selectedCryptoAmount, usdRate, currentRate, networkFee, loading, channel, currentStep, serviceFee, serviceFeeUSD, selectedFiatAmountWithoutFees, } = storeToRefs(transactionStore);
        const showRateAlert = ref(false);
        const onNewRateReceived = () => {
            showRateAlert.value = true;
            setTimeout(() => {
                showRateAlert.value = false;
            }, 5000);
        };
        const calculateCryptoAmount = (amount) => transactionStore.calculateCryptoAmount(amount);
        const changePaymentProvider = () => {
            transactionStore.resetFees();
            transactionStore.selectedChannelId = '';
            currentStep.value = TransactTypes.TransactSteps.BUY_2;
        };
        const onKeyPress = () => {
            console.log('key pressed');
        };
        return {
            selectedCrypto,
            onNewRateReceived,
            selectedCurrency,
            selectedCryptoAmount,
            numberFormat,
            usdRate,
            currentRate,
            networkFee,
            showRateAlert,
            loading,
            channel,
            calculateCryptoAmount,
            WidgetApiServiceTypes,
            changePaymentProvider,
            onKeyPress,
            serviceFeeUSD,
            serviceFee,
            selectedFiatAmountWithoutFees,
        };
    },
});
